const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/

function validVideoId(value: string | null | undefined): string | null {
  const normalized = value?.trim() ?? ''
  return VIDEO_ID_PATTERN.test(normalized) ? normalized : null
}

function isYoutubeHost(hostname: string): boolean {
  return hostname === 'youtube.com' || hostname.endsWith('.youtube.com')
}

/** mioSegno가 지원하는 HTTPS YouTube 주소에서 11자리 영상 ID를 추출합니다. */
export function youtubeVideoId(url: string): string | null {
  try {
    const parsed = new URL(url.trim())
    if (parsed.protocol !== 'https:') return null
    if (parsed.port && parsed.port !== '443') return null
    if (parsed.username || parsed.password) return null

    const hostname = parsed.hostname.toLowerCase()
    if (hostname === 'youtu.be') {
      const match = parsed.pathname.match(/^\/([A-Za-z0-9_-]{11})\/?$/)
      return validVideoId(match?.[1])
    }
    if (!isYoutubeHost(hostname)) return null

    if (parsed.pathname === '/watch') return validVideoId(parsed.searchParams.get('v'))
    const match = parsed.pathname.match(/^\/(?:embed|shorts)\/([A-Za-z0-9_-]{11})\/?$/)
    return validVideoId(match?.[1])
  } catch {
    return null
  }
}

/** 재생에 필요한 video id만 남긴 표준 URL. list/index/feature 등 부가 파라미터는 제거합니다. */
export function canonicalYoutubeUrl(url: string): string | null {
  const id = youtubeVideoId(url)
  return id ? `https://www.youtube.com/watch?v=${id}` : null
}

export function youtubeEmbedUrl(url: string): string | null {
  const id = youtubeVideoId(url)
  return id ? `https://www.youtube-nocookie.com/embed/${id}?playsinline=1` : null
}

/** 편집 화면과 저장 직전 검증에서 같은 A/B 규칙을 사용합니다. */
export function segmentRangeError(startTime: number, endTime: number, duration: number): string | null {
  if (!Number.isFinite(startTime) || !Number.isFinite(endTime)) return '세뇨 A/B 시각을 숫자로 입력해 주세요.'
  if (startTime < 0) return '세뇨 A 시작 시각은 0초 이상이어야 합니다.'
  if (endTime <= startTime) return '세뇨 B 끝 시각은 A 시작 시각보다 커야 합니다.'
  if (!Number.isFinite(duration) || duration <= 0) return '유튜브 영상 길이를 확인할 수 없습니다.'
  if (startTime >= duration) return '세뇨 A 시작 시각이 유튜브 영상 길이를 넘었습니다.'
  if (endTime > duration + 0.05) return '세뇨 B 끝 시각이 유튜브 영상 길이를 넘었습니다.'
  return null
}
